import { Navigate } from 'react-router-dom';
import type { ReactElement } from 'react';
import { getUser } from '@/utils/auth';

interface ProtectedRouteProps {
  element: ReactElement;
  requiredRole?: number;
}

export default function ProtectedRoute({
  element,
  requiredRole,
}: ProtectedRouteProps) {
  const token = localStorage.getItem('token');

  const user = getUser();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }
  if (requiredRole !== undefined && user && user.role !== requiredRole) {
    return <Navigate to="/login" replace />;
  }

  return element;
}
